module.exports = __webpack_public_path__ + "media/dne-token.8005ddcf.webm";